import { t } from "../i18n";
import { ChevronDown, ChevronUp, Printer } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import type { PrinterConfig } from "../types";
import { printerName } from "../utils";

type Props = {
  label: string;
  printers: PrinterConfig[];
  busy?: boolean;
  menuDisabled?: boolean;
  automaticMain?: boolean;
  onPrint: (printerIds: number[]) => void;
};

export function PrinterSplitButton({
  label,
  printers,
  busy = false,
  menuDisabled = false,
  automaticMain = false,
  onPrint
}: Props) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const enabledIds = printers.map((printer) => printer.id);

  useEffect(() => {
    function close(event: PointerEvent) {
      if (!rootRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, []);

  useEffect(() => {
    if (menuDisabled) {
      setOpen(false);
    }
  }, [menuDisabled]);

  return (
    <div className="split-command" ref={rootRef}>
      {open ? (
        <div className="printer-menu" role="menu">
          {printers.map((printer, index) => (
            <button
              key={printer.id}
              type="button"
              role="menuitem"
              onClick={() => {
                setOpen(false);
                onPrint([printer.id]);
              }}
            >
              <Printer />
              <span>{printerName(printer)}</span>
              {index < printers.length - 1 ? <span className="menu-separator" /> : null}
            </button>
          ))}
        </div>
      ) : null}
      <button
        type="button"
        className="split-main"
        disabled={busy || !printers.length}
        onClick={() => onPrint(automaticMain ? [] : enabledIds)}
      >
        <Printer />
        <span>{label}</span>
      </button>
      <button
        type="button"
        className="split-arrow"
        disabled={busy || menuDisabled || !printers.length}
        onClick={() => setOpen((value) => !value)}
        aria-label={open ? t("Κλείσιμο λίστας εκτυπωτών") : t("Επιλογή εκτυπωτή")}
        aria-expanded={open}
        title={t("Επιλογή εκτυπωτή")}
      >
        {open ? <ChevronUp /> : <ChevronDown />}
      </button>
    </div>
  );
}
